import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from './Sidebar';
import { IMAGES } from '../../../constants';
import MetaData from '../../layout/MetaData';
import ProtectedHeader from '../../layout/ProtectedHeader';
import { FormattedMessage } from 'react-intl';
import { cardManagement, addCard } from '../../../actions/userActions';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import $ from 'jquery';
import Loader from '../../layout/Loader';
import { makeRequestPost } from '../../../utils/apiHelper';
import { useAlert } from 'react-alert';
import { Modal, Button, Spinner } from 'react-bootstrap';
import creditImg from "../../../assets/images/credit-card.png"

const CardManagement = () => {
    const stripe = useStripe();
    const alert = useAlert();
    const elements = useElements();
    const dispatch = useDispatch();
    const [deleteCardModelOpen, setDeleteCardModelOpen] = useState(false);
    const [loading, setLoading] = useState(null);
    const [cardAddLoading, setCardAddLoading] = useState(false);
    const [cardError, setCardError] = useState('');
    const [data, setData] = useState([])
    const [showAddCardModal, setShowAddCardModal] = useState(false);
    const { cards: cardManagementData, loading: getCardLoading, } = useSelector(state => state.getcardManagement);
    const addCardState = useSelector(state => state.addCardState);

    useEffect(() => {
        dispatch(cardManagement());
    }, [dispatch]);

    const handleDeleteCard = async () => {
        if (loading?.cardId && loading?.type === 'delete') {
            setLoading({ ...loading, loading: true })
            const deleteCard = await makeRequestPost('delete-user-card', {
                payment_method_id: loading?.cardId
            });
            if (deleteCard?.status == true) {
                const updatedData = data?.filter((d) => d?.id !== loading?.cardId)
                alert.success(deleteCard?.message)
                setLoading(null)
                setData(updatedData)
                setDeleteCardModelOpen(false);
            } else {
                setLoading({ ...loading, loading: false })
                alert.error(deleteCard?.message)
            }
        }
    }
    // const handleDeleteCard = async (cardId) => {
    //     setLoading({ cardId, type: 'delete' })
    //     const deleteCard = await makeRequestPost('delete-user-card', {
    //         payment_method_id: cardId
    //     });
    //     setLoading(null)
    //     if (deleteCard?.status == true) {
    //         const updatedData = data?.filter((d) => d?.id !== cardId)
    //         alert.success(deleteCard?.message)
    //         setData(updatedData)
    //     } else {
    //         alert.error(deleteCard?.message)
    //     }
    // }

    const handleSetDefault = async (cardId) => {
        setLoading({ cardId, type: 'default' })
        const setDefault = await makeRequestPost('set-user-default-card', {
            payment_method_id: cardId
        });
        setLoading(false)
        if (setDefault?.status == true) {
            const updatedData = data?.map((d) => {
                if (d?.id === cardId) {
                    return { ...d, is_default: true };
                } else {
                    return { ...d, is_default: false };
                }
            })
            alert.success(setDefault?.message)
            setData(updatedData)
        } else {
            alert.error(setDefault?.message)
        }
    }

    const handleAddCard = async (e) => {
        try {
            setCardAddLoading(true)
            e.preventDefault();
            if (!stripe || !elements) return;
            const { error: stripeError, paymentMethod } = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardElement),
            });

            if (stripeError) {
                setCardAddLoading(false)
                setCardError(stripeError.message);
                return;
            }
            setCardError('');
            dispatch(addCard(paymentMethod?.id))
        } catch (error) {
            console.error('Fatal error in handleAddCard:', error);

        }
    }

    const handleCloseAddCardModal = () => {
        setCardError('')
        elements.getElement(CardElement).clear();
    }

    useEffect(() => {
        if (addCardState?.status) {
            $('.btn-close').click();
            setCardAddLoading(false);
            dispatch(cardManagement());
            elements.getElement(CardElement).clear();
        }
        if (addCardState?.error) {
            setCardAddLoading(false);
            setCardError('Something went wrong. Please try again.');
        }
    }, [addCardState])


    useEffect(() => {
        if (cardManagementData?.length) {
            setData(cardManagementData)
        }
    }, [cardManagementData])

    const getBrandIcon = (brand) => {
        const icons = {
            visa: "🔵",
            mastercard: "🔴",
            amex: "🟢",
            discover: "🟠",
            diners: "🟤",
            jcb: "🟣",
            unionpay: "🔷",
            rupay: "🇮🇳",
        }
        return icons[brand?.toLowerCase()] || "💳"
    }

    const getBrandColor = (brand) => {
        const colors = {
            visa: "linear-gradient(135deg, #1a1f71 0%, #0f4c75 100%)",
            mastercard: "linear-gradient(135deg, #eb001b 0%, #f79e1b 100%)",
            amex: "linear-gradient(135deg, #006fcf 0%, #00c851 100%)",
            discover: "linear-gradient(135deg, #f76b1c 0%, #ffaf00 100%)",
            diners: "linear-gradient(135deg, #4b4b4b 0%, #888888 100%)",
            jcb: "linear-gradient(135deg, #0033a0 0%, #007bc1 100%)",
            unionpay: "linear-gradient(135deg, #d81b60 0%, #1e88e5 100%)",
            rupay: "linear-gradient(135deg, #005fa3 0%, #ed1c24 100%)",
        }
        return colors[brand?.toLowerCase()] || "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    }

    const formatBrand = (brand) => {
        const brandNames = {
            visa: "Visa",
            mastercard: "Mastercard",
            amex: "American Express",
        }
        return brandNames[brand] || brand.charAt(0).toUpperCase() + brand.slice(1)
    }

    return (
        <Fragment>
            {(getCardLoading) ? <Loader /> : ""}
            <MetaData title={`Payment Info`} />
            <ProtectedHeader />
            <ul className="breadcrub">
                <li>
                    <FormattedMessage
                        id="myaccount.card_management"
                        defaultMessage="Card Management"
                    />
                </li>
                <li><img src={IMAGES.ARROW_SVG} alt="" /></li>
                <li>
                    <FormattedMessage
                        id="myaccount.card_management"
                        defaultMessage="Card Management"
                    />
                </li>
            </ul>
            <section className="container-fluid py-4 conPart">
                <div className="row">
                    <Sidebar />
                    <div className="col-md-10">
                        <h3 className="forms mt-3 fm">
                            <FormattedMessage
                                id="myaccount.card_management"
                                defaultMessage="Card Management"
                            />
                        </h3>
                        <div className="">
                            <div className="add-card-section">
                                <div className="add-card-button" >
                                    <div className="add-card-icon">
                                        <img src={creditImg} />
                                    </div>
                                    <div className="add-card-content">
                                        <h6><FormattedMessage id="paymentMethod.add.new" defaultMessage="Add New Payment Method" /></h6>
                                        <p><FormattedMessage id="card.add.securely" defaultMessage="Securely add a credit or debit card" /></p>
                                    </div>
                                    <div className="add-card-arrow"><i className="bi bi-arrow-right"></i></div>
                                    <button className="action-btn add" data-toggle="modal" data-target="#addCardModal">
                                        <i className="bi bi-trash3"></i><span>+ <FormattedMessage id="paymentMethod.add.new" defaultMessage="Add New Payment Method" /> </span>
                                    </button>
                                </div>
                            </div>
                            <div className="cards-grid">

                                {
                                    data?.length > 0 ?
                                        data?.map((stripe, cardIndex) => {
                                            const { card, is_default } = stripe;
                                            if (!card) return;
                                            return (
                                                <div key={cardIndex} className="payment-card">
                                                    <div className="card-visual" style={{ background: getBrandColor(card?.brand) }}>
                                                        <div className="card-brand">
                                                            <span className="brand-icon">{getBrandIcon(card?.brand)}</span>
                                                            <span className="brand-name">{formatBrand(card?.brand)}</span>
                                                        </div>
                                                        <div className="card-number">
                                                            <span>•••• •••• •••• {card?.last4}</span>
                                                        </div>
                                                        <div className="card-details">
                                                            <div className="cardholder-name">{card.cardholderName}</div>
                                                            <div className="expiry-date">
                                                                <span><FormattedMessage id="validThru" defaultMessage="Valid thru" /></span>
                                                                {card?.exp_month.toString().padStart(2, "0")}/{card?.exp_year}
                                                            </div>
                                                        </div>
                                                        {is_default && (
                                                            <div className="default-badge"><i className="bi bi-star-fill"></i><span><FormattedMessage id="default" defaultMessage="Default" /></span></div>
                                                        )}
                                                    </div>

                                                    <div className="card-actions">
                                                        {!is_default && (
                                                            <button className="action-btn primary" onClick={() => handleSetDefault(stripe?.id)} disabled={loading}>
                                                                {(loading?.cardId === stripe?.id && loading?.type === 'default') ? (
                                                                    <div className="spinner-border spinner-border-sm" role="status"></div>
                                                                ) : (
                                                                    <>
                                                                        <i className="bi bi-star"></i>
                                                                        <span><FormattedMessage id="makeDefault" defaultMessage="Make Default" /></span>
                                                                    </>
                                                                )}
                                                            </button>
                                                        )}
                                                        <button
                                                            className="action-btn danger"
                                                            onClick={() => {
                                                                // handleDeleteCard(stripe?.id)
                                                                setLoading({ cardId: stripe?.id, type: 'delete' })
                                                                setDeleteCardModelOpen(true)
                                                            }}
                                                            disabled={(is_default && data?.length === 1) || loading}
                                                        >
                                                            {(loading?.cardId === stripe?.id && loading?.type === 'delete') ? (
                                                                <div className="spinner-border spinner-border-sm" role="status"></div>
                                                            ) : (
                                                                <>
                                                                    <i className="bi bi-trash3"></i>
                                                                    <span><FormattedMessage id="delete" defaultMessage="Delete" /></span>
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>

                                                    {is_default && data?.length === 1 && (
                                                        <div className="card-warning">
                                                            <i className="bi bi-info-circle"></i>
                                                            <span><FormattedMessage id="paymentMethod.cannot.delete" defaultMessage="Cannot delete your only payment method" /></span>
                                                        </div>
                                                    )}
                                                </div>)
                                        }) :
                                        <></>
                                }
                            </div>


                            {/*==== Add card modal box start ====*/}
                            <div className="modal fade payment-modal" id="addCardModal" tabIndex={-1} aria-labelledby="addCardModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" >
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="card-add-modal-content modal-content">
                                        <div className="modal-header">
                                            <div className="modal-title-section">
                                                <h5 className="modal-title"><FormattedMessage id="paymentMethod.add" defaultMessage="Add Payment Method" /></h5>
                                                <p className="modal-subtitle"><FormattedMessage id="cardInfo.encrypted" defaultMessage="Your card information is encrypted and secure" /></p>
                                            </div>
                                            <button type="button" class="btn-close" hidden data-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                            <CardElement
                                                options={{
                                                    hidePostalCode:true
                                                }}
                                                className="form-control mt-3 mb-3" />
                                            {cardError && (
                                                <div className="text-danger mb-3">{cardError}</div>
                                            )}
                                        </div>
                                        <div className="modal-footer">
                                            <button className="action-btn danger btn-close" data-dismiss="modal" aria-label="Close" onClick={handleCloseAddCardModal} disabled={cardAddLoading || getCardLoading}>
                                                {(getCardLoading) ? (<div className="spinner-border spinner-border-sm" role="status"></div>) : (
                                                    <><i className="bi bi-trash3"></i><span><FormattedMessage id="cancel" defaultMessage="Cancel" /></span></>
                                                )}
                                            </button>
                                            <button className="action-btn add" disabled={getCardLoading || cardAddLoading} onClick={handleAddCard}>
                                                {(getCardLoading || cardAddLoading) ? (<div className="spinner-border spinner-border-sm" role="status"></div>) : (
                                                    <><i className="bi bi-plus-lg me-2"></i><FormattedMessage id="card.add" defaultMessage="Add Card" /></>
                                                )}
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*==== Add card modal box end ====*/}
                        </div>
                    </div>
                </div >
            </section >

            {/*==== Delete card modal box start ====*/}
            <Modal
                show={deleteCardModelOpen}
                onHide={() => {
                    setDeleteCardModelOpen(false)
                    setLoading(null)
                }}
                centered
                // backdrop="static"
                // keyboard={false}
                style={{
                    zIndex: 1050,
                }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="card-add-modal-content modal-content" style={{
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                    }}>
                        <div className="modal-header">
                            <div className="modal-title-section">
                                <h5 className="modal-title"><FormattedMessage id="delete.confirm" defaultMessage="Confirm Deletion" /></h5>
                            </div>
                            <button type="button" class="btn-close" hidden data-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body" style={{ fontSize: '16px', textAlign: 'center' }}>
                            <FormattedMessage id="delete.card.sure" defaultMessage="Are you sure you want to delete this card?" />
                        </div>
                        <div className="modal-footer">
                            <button className="action-btn danger btn-close" data-dismiss="modal" aria-label="Close" onClick={() => { setDeleteCardModelOpen(false); setLoading(null); }} disabled={loading?.loading}>
                                <><i className="bi bi-trash3"></i><span><FormattedMessage id="cancel" defaultMessage="Cancel" /></span></>
                            </button>
                            <button className="action-btn add" disabled={loading?.loading} onClick={handleDeleteCard}>
                                {(loading?.loading) ? (<div className="spinner-border spinner-border-sm" role="status"></div>) : (
                                    <><i className="bi bi-plus-lg me-2"></i><FormattedMessage id="delete" defaultMessage="Delete" /></>
                                )}
                            </button>

                        </div>
                    </div>
                </div>

            </Modal>

            {/*==== Delete card modal box end ====*/}

        </Fragment>
    )
}

export default CardManagement;